// extracted by css-extract-rspack-plugin
export default {"root":"F66mcD","label":"sPinbB"};